// 单文件引入方式

import Input from './ZuiInput.vue'

export default {
  install(Vue) {
    Vue.component('ZuiInput', Input)
  }
}

export { Input }
